/**
 * gardenDesigns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const gardenDesignsPack: ToilePack = {
    slug: 'garden-designs',
    category: 'garden',
    name: 'Garden designs',
    tagline: tagline('plans', 'yards', 'styles'),
    chips: chips('yards', 'styles'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'courtyard', label: 'Courtyard', subject: 'a small paved urban courtyard with a bench'},
        {key: 'backyard', label: 'Backyard', subject: 'a suburban backyard with a lawn and a patio'},
        {key: 'slope', label: 'Sloped yard', subject: 'a sloped front yard with steps and terraces'},
    ],
    styles: [
        {key: 'cottage', label: 'Cottage', style: 'English cottage garden, roses on an arch', palette: 'overflowing perennials', framing: 'late-spring light'},
        {key: 'xeriscape', label: 'Xeriscape', style: 'drought-tolerant xeriscape', palette: 'agaves, grasses, gravel mulch', framing: 'late-spring light'},
        {key: 'zen', label: 'Zen', style: 'Japanese zen garden, raked gravel', palette: 'moss, a stone lantern, clipped pines', framing: 'late-spring light'},
    ],
    directions: ['with a small water feature', 'in evergreen and white', 'lower upkeep, simpler planting'],
}
